import * as React from "react";
function SvgBarchart(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      ref={svgRef}
      {...props}
    >
      <g stroke="currentColor" strokeLinecap="round" strokeWidth={1.01}>
        <path d="M4 7.5v8M8 5.5v10M12 2.5v13M16 4.5v11" />
      </g>
      <path stroke="currentColor" strokeWidth={1.01} d="M0 17.5h20" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgBarchart);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
